var obj = {
    index: function() {
        // 🔒 设置网页自动关闭时间：北京时间 2025年4月30日 23:59
        var closeTime = new Date(2025, 3, 30, 23, 59, 0);
        var now = new Date();
        if (now >= closeTime) {
            document.body.innerHTML = '<div style="display:flex;justify-content:center;text-align: center;align-items:center;height:100vh;font-size:24px;font-weight:bold;">Lần thử nghiệm Tìm Kiếm Giấc Mơ này đã kết thúc, rất mong được gặp lại mọi người lần tới</div>';
            return;
        } else {
            $('.index').addClass('index-show');
        }
        this.parallax(); // 视差背景图
        this.musicPlay(); // 背景音乐
        this.countNum(); // 阿里云埋点
    },
    parallax: function() {
        var scene = document.getElementById('scene');
        var parallax = new Parallax(scene);
    },
    musicPlay: function() {
        // 背景音乐设置
        var music = new Howl({
            src: ["//download4.qcplay.com/cherry/sea_cherry/H5BGM.mp3"],
            autoplay: true,
            loop: true,
            onplay: function() {
                $('.music-btn').addClass('music-on'); //开始播放样式
            },
        });
        var musicCount = 0;

        $('.music-btn').click(function(event) {
            if (musicCount == 1) {
                music.play();
                $(this).removeClass('ani-pause'); //去除暂时播放样式
                $(this).addClass('music-on'); //开始播放样式
                musicCount = 0;
            } else {
                $(this).addClass('ani-pause') //添加暂时播放样式
                music.pause();
                musicCount = 1;
            }
        });

        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            console.log(mon_btn);

            obj.countNum(mon_btn);
        })
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                // console.log(e)
            }
        }, 500);
    },
}